module.exports = __webpack_public_path__ + "3b2c0edc176b719256bfdebabbda4476.png";